(() => {
  const init = (root) => {
    root.querySelectorAll('[data-bb-home-city-map]:not([data-ready])').forEach((section) => {
      section.dataset.ready = 'true';
      section.addEventListener('click', (event) => {
        const link = event.target.closest('[data-bb-city-filter]');
        if (!link) return;
        const input = document.querySelector('#bb-pickup-locaties [data-bb-pickup-search]');
        if (!input) return;
        input.value = link.dataset.bbCityFilter;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
